export const useStoreConfig = () => useState<StoreConfig>('storeConfig', () => ({}));

interface StoreConfig {
    minimum_password_length?: number;
    required_character_classes_number?: number;
}
